import React from 'react';
import { Spinner } from 'react-bootstrap';
import styles from './styles.module.scss';

const Loading = () => {
  return (
    <div className={styles.spinner}>
      <Spinner animation="border" />
    </div>
  );
};

Loading.propTypes = {};

Loading.defaultProps = {};

export default Loading;
